import { AppLayout } from '@/components/layout/AppLayout'

import { HomeSection } from '@/components/ui/home/HomeSection'

const HomePage = () => (
  <AppLayout flushTop bleed pageEnter="none">
    <HomeSection />
  </AppLayout>
)

export default HomePage
